import { render, staticRenderFns } from "./choose-answer-option.vue?vue&type=template&id=218cdd64&scoped=true&"
import script from "./choose-answer-option.vue?vue&type=script&lang=js&"
export * from "./choose-answer-option.vue?vue&type=script&lang=js&"
import style0 from "./choose-answer-option.vue?vue&type=style&index=0&id=218cdd64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218cdd64",
  null
  
)

export default component.exports